import React from 'react';
import FormItemEditorRender from './FormItemEditorRender';
import StringUtil from '../../utils/StringUtil';
import CommonUtil from '../../utils/CommonUtil';
require('../../styles/FormItemRender.css');
export default class FormItemEnumRender extends FormItemEditorRender
{
	constructor(props) {
		super(props);
	}
	
	getDisplay(_value)
	{
		if(_value == null || _value == undefined)
			_value = this.props.value;
		let _options = this.props.options;
		let _valueRender = _value;
		for(var i in _options)
		{
			var item = _options[i];
			if(item.value == _value)
			{
				_valueRender = item.label;
				break;
			}
		}
		return _valueRender;
	}

	render()
	{
		let _value = this.props.rowData[this.props.dataField];
		_value = this.getDisplay(_value);
		let _display = this.forLookup?"none":(this.props.group == undefined?"none":this.props.group
			.isCurrentDataFieldModified(this.props.rowData,this.props.dataField)?"block":"none");
		
		let rowStyles = this.getRowStyles();
		let _style = {padding:"3px"};
		_style.textAlign = this.props.textAlign.toLowerCase();
		let _displayStyle = this.props.displayStyle;
		if(_displayStyle && _displayStyle.Color)_style.color = _displayStyle.Color;
		if(this.props.cssStyle)
		{
			Object.assign(_style,this.props.cssStyle);
		}
		if(_display == "block")_style.backgroundColor = "#f8e8b7";

		let clientStyle = CommonUtil.getClientLayerRowStyles(window.formModuleInstance,null,"getDataGridStyle_"+this.props.gridXml.name,[this.props.rowData,this.props.dataField]);
		
		if(clientStyle)
		{
			_style = Object.assign(_style,clientStyle);
		}

		if(rowStyles)
		{
			for(let i = 0;i<rowStyles.length;i++)
			{
				let rowStyle = rowStyles[i];
				let bool = this.props.group.analysisConditionSingleRecord1(this.props.rowData,rowStyle.recordCondition);
				if(bool)
				{
					if(rowStyle.color != -1)
						_style.color = "#"+StringUtil.toColorStyleString(rowStyle.color);
							//rowStyle.color.toString(16);//原来是break 说明多个条件之间是或 现在改成了无条件覆盖
					if(rowStyle.backgroundColor != -1)
						_style.backgroundColor = "#"+StringUtil.toColorStyleString(rowStyle.backgroundColor);
							//rowStyle.backgroundColor.toString(16);
					if(rowStyle.fontSize != -1)
						_style.fontSize = rowStyle.fontSize;
					if(rowStyle.fontFamily != null)
						_style.fontFamily = rowStyle.fontFamily;
					if(rowStyle.fontWeight != null)
						_style.fontWeight = rowStyle.fontWeight;
				}
			}
		}

		let colStyles = this.getEditorStyles();
		if(colStyles)
		{
			for(let i = 0;i<colStyles.length;i++)
			{
				let colStyle = colStyles[i];
				let bool = this.props.group.analysisConditionSingleRecord1(this.props.rowData,colStyle.recordCondition);
				if(bool)
				{
					if(colStyle.color != -1)
						_style.color = "#"+StringUtil.toColorStyleString(colStyle.color);
							//colStyle.color.toString(16);//原来是break 说明多个条件之间是或 现在改成了无条件覆盖
					if(colStyle.backgroundColor != -1)
						_style.backgroundColor = "#"+StringUtil.toColorStyleString(colStyle.backgroundColor);
							//colStyle.backgroundColor.toString(16);
					if(colStyle.fontSize != -1)
						_style.fontSize = colStyle.fontSize;
					if(colStyle.fontFamily != null)
						_style.fontFamily = colStyle.fontFamily;
					if(colStyle.fontWeight != null)
						_style.fontWeight = colStyle.fontWeight;
				}
			}
		}
		let _clsName = "gongqi_render_select";
		
		if(_style.backgroundColor)_clsName+=" gongqi_render_back";
		if(_display == "block")_clsName+=" gongqi_render_version0";


		// let valueStyle=['#33CC99','#2db7f5','#ff9000','#F5222D','#EB2F96','#722ED1','#F5222D','#4682B4','#FAFAD2','#FFDAB9']
		// let valueBackStyle=['#cff3e7','#dcf1fa','#fdedd7','#FFF1F0','#FFF0F6','#F9F0FF','#FFA39E','#87CEFA','#F5F5DC','#F4A460']
		// let valueBorderStyle=['#81f1cc','#91d5ff','#facb8d','#FFA39E','#FFADD2','#D3ADF7','#FFF1F0','#87CEEB','#FFFFF0','#D2691E']
		// _style.display='flex';
		// _style.justifyContent='center';
		// let val = Number(this.props.rowData[this.props.dataField])
		// if(val>=valueStyle.length)val=Number(this.props.rowData[this.props.dataField])-10;
		// return(
		// 	<div className={_clsName} ref={ node => this.componentLabel = node } style={_style}>
		// 		<div style={{width: '80%',border: '1px solid',whiteSpace: 'nowrap',borderRadius: '4px',color:valueStyle[val] ,background: valueBackStyle[val],borderColor:  valueBorderStyle[val]}}>
		// 			{_value}
		// 		</div>
		// 		<i ref={node => this.modifiedTag = node} className="fa fa-sort-desc" aria-hidden="true" style={{color:"red",position:"absolute",top:"-3px",right:"0px",transform:'rotate(224deg) scale(1.5)',zIndex:"100",display:_display}}></i>
		// 	</div>
			
		// );
		
		return(
			<div className={_clsName} ref={ node => this.componentLabel = node } style={_style}>
				{_value}
				<i ref={node => this.modifiedTag = node} className="fa fa-sort-desc" aria-hidden="true" style={{color:"red",position:"absolute",top:"-3px",right:"0px",transform:'rotate(224deg) scale(1.5)',zIndex:"100",display:_display}}></i>
			</div>
			
		);
	}
}


// WEBPACK FOOTER //
// ./src/formItem/renders/FormItemEnumRender.js